import React, { useState} from 'react';
import { Paper, Tooltip, Typography, Modal, Select, MenuItem, Button } from '@material-ui/core';
import { MdOutlineAssignmentReturned } from 'react-icons/md';
import { makeStyles } from '@material-ui/core/styles';
import theme from '../../../../app/config/themaConfig';
import { useDispatch } from 'react-redux';
import { reassignEvbi } from '../../../domain/api/EvbiApi';

const useStyles = makeStyles((theme) => ({
    paper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '1rem',
        marginBottom: '8px',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        width: '100%',
    },
    tableCell: {
        padding: '1px 70px ', 
        flex: '1',
        width: '272px',
    },
    estadoCircle: {
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        marginRight: '10px',
    },
    iconColumn: {
        marginLeft: '10px',
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    modalPaper: {
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '2%',
    },
}));

const getColorForEstado = (estado) => {
    if (estado === 'ACTIVO') {
        return 'green';
    } else if (estado === 'INACTIVO') {
        return 'red';
    } else {
        return 'gray';
    }
};

const primaryColor = theme.palette.primary.main;

const formatFecha = (fechaStr) => {
    if (!fechaStr) {
        return '-';
    }

    const fecha = new Date(fechaStr);
    const dia = fecha.getDate();
    const mes = fecha.getMonth() + 1;
    const año = fecha.getFullYear();
    const horas = fecha.getHours();
    const minutos = fecha.getMinutes();

    const diaStr = dia < 10 ? `0${dia}` : dia;
    const mesStr = mes < 10 ? `0${mes}` : mes;
    const horasStr = horas < 10 ? `0${horas}` : horas;
    const minutosStr = minutos < 10 ? `0${minutos}` : minutos;

    return `${diaStr}/${mesStr}/${año} ${horasStr}:${minutosStr}`;
};

const ListModGeneral = ({ modulo, estado, ultimaConexion, ultimaMedicion, evbi, icon, moduloid, evbiOptions,reload,nombre}) => {
    const classes = useStyles();
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedEvbi, setSelectedEvbi] = useState('');
    const [selectedModuleId, setSelectedModuleId] = useState('');
    const dispath = useDispatch();



    const handleOpenModal = (moduleId) => {
        setSelectedModuleId(moduleId);
        setModalOpen(true);
    };
    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handleEvbiSelection = (event) => {
        setSelectedEvbi(event.target.value);
    };
    const handleReassignEvbi = async () => {
        try {
            const evbiId = selectedEvbi && typeof selectedEvbi === 'object' ? selectedEvbi.id : selectedEvbi;

            await reassignEvbi(dispath, selectedModuleId, evbiId);

            handleCloseModal();
            reload()
        } catch (error) {
            console.error('Error reassigning EVBI:', error);

        }
    };
    const clearData = () => {
        setSelectedEvbi('');
        setModalOpen(false);
    };


    return (
        <>
            <Paper className={classes.paper}>
                <div className={classes.tableCell} style={{ width: '13%' }}>
                    <Typography variant="h5" style={{ textAlign: 'left', fontSize: '25px', fontFamily: "'Segoe UI Variable Static Display 700', sans-serif", marginLeft: '-70%' }} color='primary'>
                        {nombre || '-'}
                    </Typography>
                </div>
                <div className={classes.tableCell}>
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '35%',width:'105%' }}>
                        <div
                            className={classes.estadoCircle}
                            style={{ backgroundColor: getColorForEstado(estado), marginLeft: '-10%' }}
                        ></div>
                        <Typography variant="body1" style={{ textAlign: 'left', fontFamily: "'Segoe UI Variable Static Display 700', sans-serif" }}>
                            {estado || '-'}
                        </Typography>
                    </div>
                </div>
                <div className={classes.tableCell}>
                    <Typography variant="body1" style={{ textAlign: 'left', fontFamily: "'Segoe UI Variable Static Display 700', sans-serif", marginLeft: '-30%' }}>
                        {formatFecha(ultimaConexion)}
                    </Typography>
                </div>
                <div className={classes.tableCell}>
                    <Typography variant="body1">
                        {evbi}
                    </Typography>
                </div>
                <div className={`${classes.tableCell} ${classes.iconColumn}`}>
                    <Tooltip title="Reasignar" aria-label="top-end">
                        <MdOutlineAssignmentReturned style={{ fontSize: '25px', color: theme.palette.primary.main }} onClick={() => handleOpenModal(moduloid)} />
                    </Tooltip>
                </div>
            </Paper>
            <Modal
                className={classes.modal}
                open={isModalOpen}
                onClose={clearData}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <div className={classes.modalPaper}>
                    <Typography variant="h6" id="modal-title" style={{color:primaryColor,fontWeight:'bold',textAlign:'center'}}>
                        Reasignar EVBI
                    </Typography>
                    <Typography variant="h6" id="modal-title"
                        style={{ marginBottom: '5%',color:'transparent' }}>
                        ________________________________
                    </Typography>
                    <Select value={selectedEvbi} onChange={handleEvbiSelection} style={{ width: '70%', marginLeft: '15%', marginTop: '10%' }}>
                        {evbiOptions.map((evbiOption) => {
                            return (
                                <MenuItem key={evbiOption.id} value={evbiOption.id}>
                                    {evbiOption.name}
                                </MenuItem>
                            );
                        })}
                    </Select>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleReassignEvbi}
                        style={{ marginTop: '40px', marginLeft: '35%' }}
                    >
                        Reasignar
                    </Button>
                </div>
            </Modal>
        </>
    );
};

export default ListModGeneral;
